/* import __COLOCATED_TEMPLATE__ from './assignee-dropdown-with-fallback.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { senderTypes } from 'embercom/models/data/outbound/constants';
import { inject as service } from '@ember/service';

export default class AssigneeDropdownWithFallback extends Component {
  @service appService;

  get app() {
    return this.appService.app;
  }
  get isOwnerSelected() {
    return this.isOwnerWithAssigneeFallback || this.isOwnerWithCustomEmailAddressFallback;
  }

  get isOwnerWithAssigneeFallback() {
    return this.args.selectedValueType === senderTypes.owner;
  }

  get isOwnerWithCustomEmailAddressFallback() {
    return this.args.selectedValueType === senderTypes.ownerWithCustomEmailAddressFallback;
  }

  get selectedValue() {
    if (this.isOwnerSelected) {
      return '-1';
    } else if (this.args.selectedValueId) {
      return `${this.args.selectedValueId}:${this.args.selectedValueType}`;
    } else {
      return undefined;
    }
  }

  get selectedFallbackValue() {
    if (this.isOwnerSelected && this.args.selectedValueId) {
      let fallbackValueType = this.isOwnerWithAssigneeFallback
        ? senderTypes.admin
        : senderTypes.customEmailAddress;
      return `${this.args.selectedValueId}:${fallbackValueType}`;
    } else {
      return undefined;
    }
  }

  isAiAgentSelected(selectedValue) {
    if (!selectedValue || !this.app.operatorBot) {
      return false;
    }

    let [senderId] = selectedValue.split(':', 2);
    return this.app.operatorBot.id.toString() === senderId;
  }

  @action onSelectItem(newValue) {
    let [senderId, senderType] = newValue.split(':', 2);
    if (newValue === '-1') {
      if (this.args.selectedValueType === senderTypes.customEmailAddress) {
        this.args.onChangeType(senderTypes.ownerWithCustomEmailAddressFallback);
      } else {
        this.args.onChangeType(senderTypes.owner);
      }
    } else if (this.args.supportOldEditor) {
      this.args.onChangeId(newValue);
      this.args.onChangeType(Number(senderType));
    } else {
      this.args.onChangeId(Number(senderId));
      this.args.onChangeType(Number(senderType));
    }

    // If AI Agent (Fin) is selected as sender, auto-assign to Operator bot
    if (this.args.aiAgentAllowed && this.isAiAgentSelected(newValue)) {
      if (this.args.localizedContent && this.app.operatorBot) {
        this.args.localizedContent.assignToId = this.app.operatorBot.id.toString();
        this.args.localizedContent.assignToType = this.app.operatorBot.outboundType;
      }
    }
  }

  @action onSelectFallbackItem(newValue) {
    let [senderId, senderType] = newValue.split(':', 2);
    if (this.args.supportOldEditor) {
      this.args.onChangeId(newValue);
      this.args.onChangeType(Number(senderType));
    } else {
      this.args.onChangeId(Number(senderId));
    }
    if (Number(senderType) === senderTypes.customEmailAddress) {
      this.args.onChangeType(senderTypes.ownerWithCustomEmailAddressFallback);
    } else {
      this.args.onChangeType(senderTypes.owner);
    }
  }
}
